export { default as CookiesConsent } from './component';
